import { Trans, useTranslation } from "react-i18next";
import BarChart from "./BarChart";

const ChartSection = () => {
  const { t } = useTranslation();

  return (
    <section className="relative pt-32 lg:pt-44">
      <div className="max-w-screen-xl flex flex-col lg:flex-row items-center gap-x-24 gap-y-12 mx-8 lg:ml-44 2xl:mx-auto">
        <h2 className="text-center text-8xl text-allsafe-black-500 font-Roboto font-extrabold underline max-w-max lg:text-9xl lg:leading-30">
          <Trans>JA!</Trans>
        </h2>
        <div className="max-w-3xl">
          <p className="font-Roboto text-allsafe-black">
            {t("Auf die Wahl des Aluminiums kommt es an.")}
          </p>
          <ul className="mb-8 ml-4 list-outside list-square">
            <li className="font-Roboto ">
              <Trans>
								Einsatz erneuerbarer Energien im gesamten Herstellungsprozess
              </Trans>
            </li>
            <li className="font-Roboto">
              <Trans>Kurze Transportwege durch Produktion in Europa</Trans>
            </li>
          </ul>
          <div className="font-Roboto">
            <Trans i18nKey="index4">
							Bereits jetzt beziehen wir jährlich 2.840 Tonnen REDUXA
            </Trans>
          </div>
        </div>
      </div>
      <BarChart />
    </section>
  );
};

export default ChartSection;
